import { Component, HostBinding, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { DataService } from '../../../../services/data.service';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issue-beyond-emergency-credit-grid-item',
    templateUrl: './issues-beyond-emergency-credit-grid-item.component.html',
    host: { 'class': 'dash-grid--item half module drop-shadow bottom expandable ' }
})
export class IssuesBeyondEmergencyCreditGridItemComponent implements OnDestroy {

    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;

    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService
    ) {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];

        let querySiteId : number = getQueryParamFromAncestorRoute(this.route, 'siteId');

        if (this.siteId !== undefined && this.siteId === querySiteId) { return; }

        this.siteId = querySiteId;

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['beyondEmergencyPage']) {
                    this.page = +queryParams['beyondEmergencyPage'];
                } else { this.page = 1 }
            }));

        this.getData();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getPage(page: number) {
        this.page = page;
        this.getData();
    }

    getData() {
        this.issueService.issuePAYGEmergencyCreditDetail(this.clientId, this.page, this.pageSize, null, this.siteId).then((result) => {

            if (result && result.items.length > 0) {
                this.data = result.items;
                this.totalPages = result.totalPages;
                this.pageSize = result.pageSize;
                this.page = result.currentPage;
            } else { this.dataService.beyondEmergencyCreditItemComponentResolved.next(false); }
        }, error => this.dataService.beyondEmergencyCreditItemComponentResolved.next(false)
        )
    }

    onInfoClick() {
        swal({
            title: 'Beyond emergency credit',
            html: '<p style="text-align: left;">Emergency credit (E/C) acts as an overdraft for consumers who are no longer in credit.</p>\
            <p style="text-align: left;">This widget highlights consumers whose credit status is beyond their set E/C limit.</p>\
            <p style="text-align: left;">Consumers with meters that continue to register usage despite being beyond their E/C limit should be investigated as a priority. This may suggest a fault or tampering as well as carrying a risk of causing fuel poverty or increasing debt risk to you.</p>\
            <p style="text-align: left;">Where a consumer’s meter has stopped registering usage following exhaustion of their E/C they have no supply, you may wish to consider this is as a welfare issue as well an increased debt risk and fuel poverty. Please note, standing charges continue to accrue on PAYG.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
